import { createMiddleware } from '@shared/redux';

import { GET_REPORT_FOR_CUSTOMER_ID_REQUEST_SUCCEEDED } from '@domain/dashboard/metrics-report/metrics-report.state';
import { GET_CAMPAIGNS_CUSTOMER_ID_REQUEST_SUCCEEDED } from '@domain/dashboard/campaigns/campaigns.state';
import { getObjectSelectedData } from '@domain/object-selected/object-selected.state';
import { getObjectSelectedFields, isObjectSelectedMocked } from '@domain/object-selected/object-select.utils';
import { analytics } from '../../analytics';

const commonReportsMiddleware = eventName => async (state) => {
    const objectSelected = getObjectSelectedData(state);
    const isMocked = isObjectSelectedMocked(objectSelected);

    if (isMocked) return;

    const { id, ...rest } = getObjectSelectedFields(objectSelected);

    const properties = {
        ...rest,
        entityId: id,
    };
    await analytics.track(eventName, properties);
};

export const dashboardReportsMiddleware = createMiddleware({
    [GET_REPORT_FOR_CUSTOMER_ID_REQUEST_SUCCEEDED]: commonReportsMiddleware('dashboard_metrics_report_succeeded'),
    [GET_CAMPAIGNS_CUSTOMER_ID_REQUEST_SUCCEEDED]: commonReportsMiddleware('dashboard_campaigns_report_succeeded'),
});
